<div style="page-break-inside: avoid;" class="container mt-5 py-5" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'">
      <div class="row pb-3">
        <div class="col-12 text-center"><u>Instructions to fill up the Return Form</u></div>
      </div>

      <div class="row mt-4 mb-5" style="border: 2px solid black">
        <div class="col-12 p-2">
          <div class="row mb-1">
            <div class="col-12">
              <u><strong> Instructions:</strong></u>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (1)
            </div>
            <div class="col-11 text-justify">
              This Return of Income shall be Signed and Verified by the Taxpayer or his Authorized Representative as prescribed in the Income Tax Act, 2023
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (2)
            </div>
            <div class="col-11 text-justify">
              <u>Enclose where applicable</u>:
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
                (a) Salary statement for salary; Bank statement for interest; Certificate for interest on savings instruments;
                Rent agreement, receipts of municipal tax & land revenue, statement of house property loan interest, insurance premium for house property income;
                Statement of Professional income as per IT Rule-8; Copy of assessment/income statement & balance sheet for partnership income;
                Documents of capital gain; Dividend warrant for dividend income; Statement of other income; Documents in support of investments in savings certificates, LIP, DPS, Zakat, stock/share etc.
              </span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
              (b) Depreciation Chart claiming depreciation as per the Income Tax Act, 2023;
            </span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
              (c) Computation of Income according to the Income Tax Act, 2023.</span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (3)
            </div>
            <div class="col-11 text-justify">
              <u>Enclose Separate Statement for:</u>:
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
               (a) any income of the spouse of the Taxpayer (if she/he is not an Taxpayer), minor children and dependent;
              </span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
              (b) Tax exempted / Tax free Income.
              </span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
              (c) Income Exempted from Tax declared under Part 1 of the Sixth Schedule of the Income Tax Act, 2023.
              </span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (4)
            </div>
            <div class="col-11 text-justify">
              Documents furnished to support the declaration should be signed by the Taxpayer or his/her authorized representative.
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (5)
            </div>
            <div class="col-11 text-justify">
              <u>Furnish the following information</u>:
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
                (a) Name, address & TIN of the partners if the Taxpayer is a firm;
              </span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
              (b) Name of firm, address & TIN if the Taxpayer is a partner;
              </span>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-1 text-center"></div>
            <div class="col-11 text-justify">
              <span class="d-inline-block" style="text-indent: -1.9em; padding-left: 1.8em;">
                (c) Name of the company, address & TIN if the Taxpayer is a director.
                </span>
              </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (6)
            </div>
            <div class="col-11 text-justify">
              Assets and liabilities of self, spouse (if she/he is not a Taxpayer), minor children and dependant(s) to be shown in the IT-10B (2023).
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (7)
            </div>
            <div class="col-11 text-justify">
              Signature is mandatory for all Taxpayer or his / her authorized representative.
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-1 text-center">
              (8)
            </div>
            <div class="col-11 text-justify">
              For Individual Person, signature is also mandatory in IT-10B (2023) & IT-10BB (2023).
            </div>
          </div>


          <div class="row mb-1">
            <div class="col-1 text-center">
              (9)
            </div>
            <div class="col-11 text-justify">
              If needed, please use separate sheet.
            </div>
          </div>

          <div class="blank-space"></div>

        </div>
      </div>
</div>